<template>
    <input
        type="text"
        class="form-control"
        name="username"
        v-model="username"
        v-on:input="onValueChange"
        v-on:keyup.enter="login"
        v-bind:placeholder="label"
        v-bind:class="myClass"
        required="required" />
</template>

<script>
import store from '../store/store';
import { mapActions, mapMutations } from 'vuex';
/**
 * Component displays input that allow user to enter username.
 * @tag z-login-username-input
 */
export default {
    name: 'LoginUsernameInput',
    store,
    props: {
        /**
         * Makes input required.
         * @example required
         */
        required: {
            type: Boolean,
            default: true
        },
        /**
         * Text will be displayed as input's placeholder.
         * @example label="Example"
         */
        label: {
            type: String,
            default: 'Username'
        },
        /**
         * Adds class to input element.
         * @example my-class="Example"
         */
        myClass: {
            type: String
        }
    },
    data: function () {
        return {
            username: ''
        };
    },
    created() {
        if (this.required) {
            store.commit('login/required', 'username');
        }
    },
    methods: {
        ...mapActions('login', [ 'login' ]),
        ...mapMutations('login', {
            setLoginError:'error',
            setUsername:'username',
        }),
        onValueChange: function () {
            this.setLoginError(null);
            this.setUsername(this.username);
        },
    }
};
</script>

<style>
</style>
